var mapImagePathsToHashedVersions = function (requireContext) {
    var images = {};
    requireContext.keys().forEach(function (fileName) {
        var key = fileName.replace('./', '');
        // Use full path as key
        images[key] = requireContext(fileName);
    });
    return images;
};
var images = mapImagePathsToHashedVersions(require.context('../assets/images', true, /\.(png|jpg|jpeg|gif|svg)$/));
var getImagePathWithHash = function (path) {
    if (images[path]) {
        return images[path];
    }
    // Temporarily so we can see in Sentry.
    console.error('Image path not exist: ', path);
    return path;
};
export { images as default, getImagePathWithHash };
